function productsSliderInit(){
  $('.products-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: false,
    prevArrow: `<button type="button" class="slick-prev"><span class="visually-hidden">Previous</span>${window.iconStrings.previousControl}</button>`,
    nextArrow: `<button type="button" class="slick-next"><span class="visually-hidden">Next</span>${window.iconStrings.nextControl}</button>`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: false,
          variableWidth: true
        }
      }
    ]
  });
}

if( $('.products-slider').length ){
  productsSliderInit();
}

$b.on('recommendationsLoaded', function(){
  productsSliderInit();
});